import { ReactNode, useEffect } from 'react';

import { useRouter } from 'next/router'

import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js"

import { AppConfig } from '@/utils/AppConfig'
import { useCookie } from '@/utils/Session'

import { Footer } from '@/layout/Footer';

type IPaymentPageProps = {
  meta: ReactNode;
  children: ReactNode;
};

const PaymentPage = (props: IPaymentPageProps) => {
  const router = useRouter();
  const [isLoggedIn] = useCookie('loggedIn')
  const [sessionId] = useCookie('sessionId');

  useEffect(() => {
    if (!isLoggedIn()) {
      router.push('/login?redirect=checkout')
    }
  }, [])

  return (
    <PayPalScriptProvider options={{ 
      clientId: "AQRQKhJPYEIZbfiHFUNxja3OccWYaGPYt2DFCNWnS4qGdbBYM4FbeoEGQZadPlWsqON1uYRZOpH_VC3I",
      vault: true,
      intent: "subscription",
    }}>

    <img
      className="w-full object-cover -z-30 absolute top-0 left-0"
      src={`${router.basePath}/assets/images/bing-bot.jpeg`}
      alt="Database watercolor"
    />
      <div className="max-w-screen-md mx-auto bg-white pt-0 p-7">
        <div className="max-w-screen-md mx-auto">
          <header className="border-b border-gray-300">
            <div className="pt-16 pb-8">
              <div className="font-bold text-3xl text-gray-900">
                {AppConfig.title}
              </div>
              <div className="text-xl">Checkout</div>
            </div>
          </header>
          <div className="flex flex-row mt-10">
            <section className="flex-auto">
                <h3 className='text-center font-bold text-lg text-gray-500 mb-5'>YOUR ORDER</h3>
                <table className='w-11/12'>
                  <thead className='h-10'>
                    <tr>
                      <th className="text-left">Product</th>
                      <th className="text-right">Cost</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="text-left italic">Paid Plan</td>
                      <td className="text-right italic">$100.00/mth</td>
                    </tr>
                    <tr>
                      <td>
                        <ul className="marker:text-sky-400 list-disc ml-4 text-sm">
                          <li>On Demand Refreshes</li>
                          <li>Hourly Automatic Refreshes</li>
                          <li>3 Concurrent Connections</li>
                          <li>100 Queries Per Hour</li>
                        </ul>
                      </td>
                    </tr>
                  </tbody>
                </table>
            </section>
            <section className="flex-auto">
              <h3 className='text-center font-bold text-lg text-gray-500 mb-5'>CHOOSE PAYMENT METHOD</h3>
            <PayPalButtons
              createSubscription={async (data, actions) => {
                const r = await fetch("/api/paypal/subscriptions", {
                  method: "POST"
                })
                
                const parsed = await r.json()
                console.info(`subscription`, parsed)

                return parsed.id
              }}
              onApprove={async (data, actions) => {
                const r = await fetch(`/api/paypal/subscriptions/${data.subscriptionID}/save`, {
                  headers: {
                    Session: sessionId(),
                  },
                  method: 'POST'
                })
                
                const parsed = await r.json()
                console.info(`subscription`, parsed)

                router.push('/account/')
              }}
            />
            </section>
			</div>
			</div>
		<Footer />
      </div>
  </PayPalScriptProvider>
  )
}

export { PaymentPage }